
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { CreateTechniqueFormValues } from './FormSchema';

interface BasicInfoFieldsProps {
  form: UseFormReturn<CreateTechniqueFormValues>;
  isAdminCreating?: boolean;
}

export const BasicInfoFields: React.FC<BasicInfoFieldsProps> = ({ form, isAdminCreating = false }) => {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Technique Name</FormLabel>
            <FormControl>
              <Input placeholder="Enter technique name" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Only show privacy toggle for non-admin creation */}
      {!isAdminCreating && (
        <FormField
          control={form.control}
          name="isPrivate"
          render={({ field }) => (
            <FormItem className="flex flex-row items-end space-x-3 space-y-0 rounded-md border p-3">
              <FormControl>
                <Checkbox
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel>
                  Private Technique
                </FormLabel>
                <FormDescription>
                  Only visible to you if checked
                </FormDescription>
              </div>
            </FormItem>
          )}
        />
      )}
    </div>
  );
};
